export default __webpack_public_path__ + "static/monster-6a3107bf3f418b5dfaf5bb337f971680.png";